<div class="container common-header-app madero-style" ui-view></div>
